import React from "react";

interface ReviewSummaryProps {
  recipientCount: number;
  frequency: string;
  scheduledDate: string;
  type: string;
}

/**
 * ReviewSummary - Bottom summary bar showing schedule details
 */
const ReviewSummary: React.FC<ReviewSummaryProps> = ({
  recipientCount,
  frequency,
  scheduledDate,
  type,
}) => {
  return (
    <div className="su-section su-review-summary">
      <div className="su-review-summary-header">
        <span className="su-review-summary-label">REVIEW SUMMARY</span>
      </div>

      <div className="su-review-summary-grid">
        <div className="su-review-summary-item">
          <span className="su-review-summary-item-label">Recipients</span>
          <span className="su-review-summary-item-value">
            {recipientCount} contact{recipientCount !== 1 ? "s" : ""}
          </span>
        </div>

        <div className="su-review-summary-item">
          <span className="su-review-summary-item-label">Frequency</span>
          <span className="su-review-summary-item-value">{frequency}</span>
        </div>

        <div className="su-review-summary-item">
          <span className="su-review-summary-item-label">Scheduled Date</span>
          <span className="su-review-summary-item-value">{scheduledDate}</span>
        </div>

        <div className="su-review-summary-item">
          <span className="su-review-summary-item-label">Type</span>
          <span className="su-review-summary-item-value">{type}</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewSummary;


